import React from "react";
import "../App.css";
import { Text } from "@aws-amplify/ui-react";

function TemplateProject() {
  return <Text>Hello</Text>;
}

export default TemplateProject;
